// El backend (robots-api) es agnóstico de formato: reemite `addEvents`/
// `broadcastEvents` tal cual, así que el protocolo no cambia con v13.
import Position from './position';

export default class WorkSpaceEvents {
  constructor(socket, blockly, workspace, workspaceId, projectId) {
    this.blockly = blockly;
    this.workspace = workspace;
    this.workspaceId = workspaceId;
    this.socket = socket;
    this.projectId = projectId;
  }

  async getSnapshot() {
    return new Promise((resolve) => {
      this.socket.emit('getSnapshot', this.projectId, (snapshot) => {
        resolve(snapshot);
      });
    });
  }

  getEvents(serverId) {
    return new Promise((resolve) => {
      this.socket.emit('getEvents', this.projectId, serverId, (entries) => {
        entries.forEach((item) => {
          const entry = item;
          entry.events = entry.events.map((eItem) => {
            const event = this.blockly.Events.fromJson(eItem, this.workspace);
            event.position = {
              position: Position.fromEvent(eItem, false),
              id: entry.userId,
            };
            return event;
          });
          entry.serverId = entry.id;
          entry.workspaceId = entry.userId;
        });
        resolve(entries);
      });
    });
  }

  async writeEvents(entry) {
    const entryJson = {
      workspaceId: entry.workspaceId,
      entryNumber: entry.entryNumber,
      events: entry.events.map((event) => event.toJson()),
    };
    return new Promise((resolve, reject) => {
      this.socket.emit('addEvents', this.projectId, entryJson, (res) => {
        if (!res || !res.error) {
          resolve();
        } else {
          reject(res.error);
        }
      });
    });
  }

  getBroadcast(callback) {
    // getBroadcast se llama varias veces por sesión y socket.on agrega handlers
    // en vez de reemplazarlos: registrarlo más de una vez re-aplica cada
    // broadcast y duplica bloques. Se registra una sola vez por instancia.
    this.broadcastCallback = callback;
    if (this.broadcastRegistered) {
      return;
    }
    this.broadcastRegistered = true;
    this.broadcastHandler = (projectId, entries) => {
      if (projectId !== this.projectId) {
        return;
      }
      entries.forEach((item) => {
        const entry = item;
        entry.events = entry.events
          .map((eItem) => {
            try {
              const event = this.blockly.Events.fromJson(eItem, this.workspace);
              event.position = {
                position: Position.fromEvent(eItem, false),
                id: entry.workspaceId,
              };
              return event;
            } catch (err) {
              // Un evento ajeno que no deserializa (formato viejo o tipo no
              // soportado) se descarta para no tumbar la sesión de colaboración.
              // eslint-disable-next-line no-console
              console.warn('[RB129] evento de colaboración descartado (no deserializa):', err?.message);
              return null;
            }
          })
          .filter(Boolean);
      });
      this.broadcastCallback(entries);
    };
    this.socket.on('broadcastEvents', this.broadcastHandler);
  }

  // El socket sobrevive a esta instancia: sin remover el handler, cada
  // re-montaje deja handlers viejos vivos y duplica eventos.
  dispose() {
    if (this.broadcastHandler) {
      this.socket.off('broadcastEvents', this.broadcastHandler);
      this.broadcastHandler = null;
      this.broadcastRegistered = false;
    }
  }
}
